var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _ellipse, _path9, _path0, _path1, _ellipse2, _ellipse3, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 941.94 941.94",
    style: {
      enableBackground: "new 0 0 941.94 941.94"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E9FDFF;}\r\n\t.st1{opacity:0.37;fill:url(#SVGID_1_);}\r\n\t.st2{opacity:0.37;fill:url(#SVGID_00000175295287583430816130000006867743279580418485_);}\r\n\t.st3{fill:url(#SVGID_00000088094391438229574170000002687020666702567064_);}\r\n\t.st4{fill:url(#SVGID_00000026870657836873801850000011990021505941133709_);}\r\n\t.st5{fill:url(#SVGID_00000098942244752713999340000007759165583310963865_);}\r\n\t.st6{fill:url(#SVGID_00000066476429555481465760000011055412246014531742_);}\r\n\t.st7{fill:url(#SVGID_00000004523404223137543450000002862708246666172574_);}\r\n\t.st8{fill:url(#SVGID_00000013871190207622244010000000116686433295922843_);}\r\n\t.st9{fill:url(#SVGID_00000154386478106203416860000008116568776107005095_);}\r\n\t.st10{fill:#111023;}\r\n\t.st11{fill:url(#SVGID_00000074429548322239979940000012869745312897388705_);}\r\n\t.st12{fill:url(#SVGID_00000044158411416278705700000001113600732451464380_);}\r\n\t.st13{fill:url(#SVGID_00000158749376452144704130000005029366969276404395_);}\r\n\t.st14{fill:url(#SVGID_00000158742937287735220200000013331688378168774581_);}\r\n\t.st15{fill:url(#SVGID_00000048472458954958691080000011412985723359990679_);}\r\n\t.st16{fill:url(#SVGID_00000036943558318627035710000001724846147476651166_);}\r\n\t.st17{fill:url(#SVGID_00000174582630353342386310000006733791322552827799_);}\r\n\t.st18{fill:#5B2B89;}\r\n\t.st19{fill:url(#SVGID_00000079469894137814800720000004481591905379055515_);}\r\n\t.st20{fill:url(#SVGID_00000039133191180419127970000001759887784194006400_);}\r\n\t.st21{fill:url(#SVGID_00000006671016282202168660000015580953934968102331_);}\r\n\t.st22{fill:url(#SVGID_00000109019671545427694240000003115560625520086687_);}\r\n\t.st23{fill:url(#SVGID_00000096061012336943636310000014606056633878959022_);}\r\n\t.st24{opacity:0.38;fill:url(#SVGID_00000065759939531007831370000011783681930565996950_);}\r\n\t.st25{fill:url(#SVGID_00000117655265299000786930000017763139667260242852_);}\r\n\t.st26{fill:#F79244;}\r\n\t.st27{fill:#FFFFFF;}\r\n\t.st28{opacity:0.5;fill:url(#SVGID_00000004515435904004964070000010093307130981951667_);}\r\n\t.st29{fill:url(#SVGID_00000023969786365129367790000006566120561227673522_);}\r\n\t.st30{fill:url(#SVGID_00000180365593804720206760000015959623287769763489_);}\r\n\t.st31{fill:url(#SVGID_00000064317018424460365410000007821770479911469471_);}\r\n\t.st32{fill:url(#SVGID_00000063592148837907643670000006757053273061620898_);}\r\n\t.st33{fill:#2A2A2A;}\r\n\t.st34{fill:url(#SVGID_00000134962343145300003190000005461837689188917153_);}\r\n\t.st35{fill:url(#SVGID_00000120551803341878020830000014959416321813273764_);}\r\n\t.st36{fill:url(#SVGID_00000092457231353474328730000013669945230797692814_);}\r\n\t.st37{fill:url(#SVGID_00000094618816704844862330000004315726142632584895_);}\r\n\t.st38{fill:url(#SVGID_00000090269551416865608230000004942416723654302132_);}\r\n\t.st39{fill:url(#SVGID_00000091695119279984456050000017683680777491127728_);}\r\n\t.st40{fill:url(#SVGID_00000183219328389435011070000010075262860322062740_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1_",
    x: -1306.17,
    y: 218.33,
    className: "st0",
    width: 750,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.4566,
    y1: 729.4631,
    x2: 483.5195,
    y2: 305.7133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.74,705.16H47.45c-23.9-24.82-30.29-64.38-16.01-95.73c13.6-29.89,42.82-49.64,60.51-77.31 c37.77-59.04,19.51-147,70.84-194.73c25.66-23.86,62.55-30.76,97.47-33.55c34.92-2.79,71.02-2.71,103.32-16.29 c39.83-16.74,69.85-52.69,110.88-66.24c46.06-15.21,101.17,3.77,128.09,44.13c16.84,25.25,23.2,56.98,43.12,79.88 c32.21,37.04,88.96,39.91,129.13,68.12c27.55,19.34,46.16,50.94,49.71,84.41c4.29,40.42-11.06,86.33,13.18,118.97 c11.82,15.91,30.98,24.88,43.72,40.07c12.69,15.14,16.26,28.93,12.27,48.27H136.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003818835801891602570000006904658565211673479_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.2772,
    y1: 729.4631,
    x2: 506.3401,
    y2: 305.7133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "url(#SVGID_00000003818835801891602570000006904658565211673479_)"
    },
    d: "M159.56,705.16H70.27 c-23.9-24.82-30.29-64.38-16.01-95.73c13.6-29.89,42.82-49.64,60.51-77.31c37.77-59.04,19.51-147,70.84-194.73 c25.66-23.86,62.55-30.76,97.47-33.55c34.92-2.79,71.02-2.71,103.32-16.29c39.83-16.74,69.85-52.69,110.88-66.24 c46.06-15.21,101.17,3.77,128.09,44.13c16.84,25.25,23.2,56.98,43.12,79.88c32.21,37.04,88.96,39.91,129.13,68.12 c27.55,19.34,46.16,50.94,49.71,84.41c4.29,40.42-11.06,86.33,13.18,118.97c11.82,15.91,30.98,24.88,43.72,40.07 c12.69,15.14,16.26,28.93,12.27,48.27H159.56z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067233351498889199750000007709986450263981187_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.5978,
    y1: 400.7913,
    x2: 196.5978,
    y2: 326.8923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E6D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#FCF1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    style: {
      stopColor: "#FEF9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#FFFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067233351498889199750000007709986450263981187_)"
    },
    d: "M365.08,399.4l-3.68,0.12H29.32 l-0.8,0.1c-3.3-22.03,13.94-44.4,35.64-50.33c18.97-5.19,41.18-0.57,57.06-12.18c14.24-10.39,17.78-29.82,27.09-44.78 c5.79-9.31,14.05-17.08,23.71-22.27c12.11-6.5,27.21-8.78,39.63-2.9c21.99,10.44,26.21,39.58,40.92,58.99 c3.28,4.34,7.41,8.38,12.66,9.82c4.84,1.34,9.97,0.29,14.93-0.59c16.25-2.86,35.75-2.6,45.86,10.44 c4.75,6.14,6.45,14.01,9.09,21.3c2.64,7.3,6.96,14.79,14.26,17.41c3.5,1.23,7.48,1.27,10.56,3.33 C363.65,390.34,364.85,394.77,365.08,399.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160176965213663861910000016838565690251314366_",
    gradientUnits: "userSpaceOnUse",
    x1: 703.2345,
    y1: 452.6667,
    x2: 707.9116,
    y2: 380.6386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E6D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#FCF1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    style: {
      stopColor: "#FEF9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#FFFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160176965213663861910000016838565690251314366_)"
    },
    d: "M899.22,441.33H511.97 c-3.09-4.06-3.47-10.34-1.27-15.16c2.86-6.33,8.83-10.63,14.78-14.21c5.95-3.59,12.28-6.89,16.74-12.21 c8.55-10.22,8.05-24.87,9.94-38.05c2.22-15.64,8.78-31.13,20.61-41.63c4.68-4.16,10.11-7.46,15.8-10.09 c16.22-7.54,36.3-9.44,51.46,0.07c14.5,9.09,21.61,26.38,34.26,37.91c2.98,2.74,6.4,5.19,10.35,6.11 c11.33,2.6,20.95-7.67,29.45-15.59c12.07-11.26,28.2-19.67,44.58-17.57c19.25,2.5,34.13,19.01,41.44,37 c3.05,7.49,5.38,15.78,11.45,21.11c15.58,13.65,41.87-1.65,60.03,8.27c6.82,3.73,11.38,10.51,15.02,17.38 C892.67,416.13,896.95,428.55,899.22,441.33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024001516845270561800000004408258353002268316_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.1946,
    y1: 578.6572,
    x2: 357.4193,
    y2: 578.6572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024001516845270561800000004408258353002268316_)"
    },
    d: "M357.42,656.18h-27.86v48.97h-67.48 v-48.97H161.19V606L266.4,452.17h63.16v152.97h27.86V656.18z M262.08,605.13v-29.42c0-5.54,0.2-13.01,0.61-22.41 c0.4-9.4,0.72-14.33,0.95-14.8h-1.9c-3.92,8.89-8.37,17.19-13.32,24.92l-28.03,41.7H262.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176746609047416892180000016585870486837864861_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.6646,
    y1: 721.8098,
    x2: 240.7937,
    y2: 626.3959
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E6D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#FCF1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    style: {
      stopColor: "#FEF9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#FFFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176746609047416892180000016585870486837864861_)"
    },
    d: "M338.99,656.19h-27.86v48.97h-67.48 v-48.97H142.77v-50.18l105.21-153.83h63.16v152.97h27.86V656.19z M243.65,605.15v-29.42c0-5.54,0.2-13.01,0.61-22.41 c0.4-9.4,0.72-14.33,0.95-14.8h-1.9c-3.92,8.89-8.37,17.19-13.32,24.92l-28.03,41.7H243.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078043008401920579880000001883652004047766715_",
    gradientUnits: "userSpaceOnUse",
    x1: 546.0919,
    y1: 875.3187,
    x2: 742.3228,
    y2: 875.3187,
    gradientTransform: "matrix(0.9818 -0.1899 0.1899 0.9818 -112.538 -139.7248)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078043008401920579880000001883652004047766715_)"
    },
    d: "M797.8,657.87l-9.7-50.13l-18.09,3.5 l-9.26,1.79l-29.03-150.19l-62.02,12l-74.08,171l9.52,49.28l99.05-19.17l5.64,29.19h68.74l-8.12-41.99l9.26-1.79L797.8,657.87z  M676.4,629.36l-22.84,4.41l16.3-38.47l3.3-7.79c3.4-8.53,6.17-17.54,8.34-27.01l1.87-0.35c-0.14,0.49,0.49,5.39,1.87,14.71 c1.39,9.3,2.6,16.67,3.66,22.11l5.58,28.88L676.4,629.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106116934124375570540000011749190344132385980_",
    gradientUnits: "userSpaceOnUse",
    x1: 679.7488,
    y1: 713.2395,
    x2: 677.878,
    y2: 617.8256
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E6D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#FCF1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    style: {
      stopColor: "#FEF9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#FFFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106116934124375570540000011749190344132385980_)"
    },
    d: "M779.71,661.38l-9.7-50.11l-27.35,5.29 l-29.05-150.19l-43.92,8.48l-18.09,3.5l-74.08,171.02l9.52,49.26l18.09-3.5l80.96-15.64l4.96,25.67h68.74l-7.44-38.49l18.09-3.5 L779.71,661.38z M669.86,595.3c0.33,1.89,0.66,3.61,0.95,5.19l5.58,28.88l-40.95,7.93l19.62-46.28 c3.4-8.52,6.17-17.52,8.34-26.99l1.87-0.36c-0.14,0.5,0.49,5.41,1.87,14.71C668.15,584.99,669.05,590.65,669.86,595.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059274758392510812820000007742450274967346850_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.0699,
    y1: 458.168,
    x2: 341.5721,
    y2: 443.8247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059274758392510812820000007742450274967346850_)"
    },
    d: "M366.84,576.84l-41.2,0L299.46,385.2 c0,0-37.82-41.31-81.23-49.05l41.35-4.46l93.19,2.53L366.84,576.84z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M204.23,471.49c0,0-23.41,34.26-13.02,63.68l43.55-63.68l-5.66-7.6L204.23,471.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M325.64,576.84l-1.4,8.85c0,0-12.41,1.74-13.1,19.46h32.28l17.54-17.12l1.64-11.19H325.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157292531381532930360000002600293726015708562_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.9025,
    y1: 405.4523,
    x2: 299.4627,
    y2: 405.4523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157292531381532930360000002600293726015708562_)"
    },
    d: "M275.8,385.06l-51.63-1.93l8.39,79.07 l-35,12.54l-20.17-97.65c-5.9-18.19,6.43-37.22,25.44-39.29l15.38-1.67h0.02c43.41,7.74,81.23,49.05,81.23,49.05L275.8,385.06z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127733079458101209500000000952324877027645877_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.8744,
    y1: 159.7183,
    x2: 180.7165,
    y2: 159.7183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#51ADC6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0060817,
    style: {
      stopColor: "#55AFC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0663,
    style: {
      stopColor: "#74BFB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    style: {
      stopColor: "#8FCDA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2102,
    style: {
      stopColor: "#A5D89D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3001,
    style: {
      stopColor: "#B6E094"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    style: {
      stopColor: "#C1E78E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5672,
    style: {
      stopColor: "#C8EA8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CAEB8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127733079458101209500000000952324877027645877_)"
    },
    d: "M180.72,164.36v2.3l-2.8,0.36 c-0.72-1.55-1.49-2.78-2.25-3.46c-3.74-3.22-6.33-5.75-9.01-4.21c-2.02,1.17-1.86,6.69-1.67,9.3l-7.62,0.97l-67.46,8.55 l-0.03-0.13c4.38-1.03,7.77-8.88,7.77-18.42c0-9.41-3.3-17.17-7.58-18.39l90.65,10.23v1.83V164.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005235591198084657250000004735409035635329939_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.9255,
    y1: 149.2172,
    x2: 80.2256,
    y2: 149.2172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8AEBD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#89E9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#84E2DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    style: {
      stopColor: "#7DD7DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8419,
    style: {
      stopColor: "#72C6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    style: {
      stopColor: "#64B0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#5395F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5193FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005235591198084657250000004735409035635329939_)"
    },
    d: "M94.93,146.19 c-0.19,0.28-0.36,0.56-0.52,0.86c-0.97,1.88-1.42,4.02-2.63,5.74c-0.88,1.28-2.14,2.27-3.58,2.83 c-1.52,0.59-3.17,0.69-4.8,0.91c-1.08,0.14-2.19,0.36-3.17,0.81c0.52-9.01,4.07-16.01,8.43-16.25l1.41,0.16 C91.94,141.78,93.63,143.56,94.93,146.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008851107664480430770000002533468022409147068_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.6152,
    y1: 158.0137,
    x2: 80.1474,
    y2: 158.0137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008851107664480430770000002533468022409147068_)"
    },
    d: "M97.62,158.12 c-0.03,0.03-0.05,0.06-0.08,0.09c-1.11,1.49-1.64,3.35-2.67,4.88c-1.2,1.8-3.13,3.11-5.24,3.6c-1.95,0.44-4.07,0.2-5.85,1.09 c-0.91,0.47-1.64,1.19-2.19,2.05c-0.91-2.92-1.44-6.43-1.44-10.2c0-0.78,0.02-1.55,0.08-2.3c0.99-0.45,2.1-0.67,3.17-0.81 c1.63-0.22,3.28-0.31,4.8-0.91c1.44-0.56,2.71-1.55,3.58-2.83c1.2-1.72,1.66-3.86,2.63-5.74c0.16-0.3,0.33-0.58,0.52-0.86 C96.44,149.26,97.44,153.43,97.62,158.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090991083900188675110000012808555547416981910_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.6465,
    y1: 168.155,
    x2: 81.5861,
    y2: 168.155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8AEBD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#89E9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#84E2DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    style: {
      stopColor: "#7DD7DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8419,
    style: {
      stopColor: "#72C6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    style: {
      stopColor: "#64B0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#5395F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5193FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090991083900188675110000012808555547416981910_)"
    },
    d: "M97.65,159.64 c0,9.54-3.39,17.39-7.77,18.42c-0.31,0.08-0.66,0.13-0.99,0.13c-3.05,0-5.74-3.32-7.3-8.35c0.55-0.86,1.28-1.58,2.19-2.05 c1.78-0.89,3.89-0.66,5.85-1.09c2.11-0.48,4.03-1.8,5.24-3.6c1.03-1.53,1.56-3.39,2.67-4.88c0.03-0.03,0.05-0.06,0.08-0.09 C97.63,158.62,97.65,159.12,97.65,159.64z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M234.14,155.11h27.27c-2.85,1.14-5.27,2.44-6.36,3.47c-0.86,0.8-0.48,2.25,0.58,4.11h-21.49V155.11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M294.58,159.67v3.02H279.8c-1.42-3.28-2.49-6.05-2.85-7.58h17.62V159.67z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142177560203539046170000002570336889075511992_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.7165,
    y1: 158.8347,
    x2: 234.1365,
    y2: 158.8347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000142177560203539046170000002570336889075511992_)"
    },
    points: "234.14,162.69 234.14,164.36  180.72,164.36 180.72,153.31 234.14,153.31 234.14,155.11  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181807373811005320710000004266938589808147341_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.3516,
    y1: 175.5452,
    x2: 182.8277,
    y2: 175.5452
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7BE86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3293,
    style: {
      stopColor: "#F7BC83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#F7B67B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7276,
    style: {
      stopColor: "#F7AC6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      stopColor: "#F79E57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181807373811005320710000004266938589808147341_)"
    },
    d: "M182.83,183.25l-11.76,8.94 c0,0-14.28-14.97-13.7-22.57l7.62-0.97c-0.19-2.61-0.34-8.13,1.67-9.3c2.67-1.55,5.27,0.99,9.01,4.21 c0.77,0.67,1.53,1.91,2.25,3.46C180.67,172.92,182.83,183.25,182.83,183.25z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M103.7,141.32c-0.79-1.72-3.33-0.25-2.55,1.45c4.84,10.58,4.22,22.23-1.58,32.29 c-0.94,1.64,1.6,3.11,2.54,1.47C108.44,165.53,108.96,152.85,103.7,141.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001648577950062728520000009620984931653276575_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.8237,
    y1: 195.0178,
    x2: 306.9803,
    y2: 225.6616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B6ED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    style: {
      stopColor: "#796DD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    style: {
      stopColor: "#7268D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    style: {
      stopColor: "#6760C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    style: {
      stopColor: "#5655BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#4047B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333EA8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000001648577950062728520000009620984931653276575_)"
    },
    points: "313.14,195.06 313.14,204.13  302.29,193.87  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004519148076599786020000009207254576612338583_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.476,
    y1: 195.4211,
    x2: 326.2269,
    y2: 266.5484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B6ED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    style: {
      stopColor: "#796DD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    style: {
      stopColor: "#7268D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    style: {
      stopColor: "#6760C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    style: {
      stopColor: "#5655BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#4047B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333EA8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004519148076599786020000009207254576612338583_)"
    },
    d: "M313.14,204.13l10.93,10.32 l10.43,9.85c0,0,23.9-16.73,33.17-16.87c0.66-0.02,1.28,0.03,1.89,0.13c8.18,1.16,13.18,10.62,11.74,19.69 c-1.55,9.77-1.27,20.6-10.68,22.35c-9.41,1.77-50.89,11.82-50.89,11.82l-45.4-61.58l5.35-3.74l11.92-8.34l2.41-1.69l5.24,4.94 l3.03,2.86L313.14,204.13z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052099305861343748990000013736273985181812372_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.2274,
    y1: 196.1023,
    x2: 346.384,
    y2: 226.7461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B6ED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    style: {
      stopColor: "#796DD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    style: {
      stopColor: "#7268D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    style: {
      stopColor: "#6760C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    style: {
      stopColor: "#5655BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#4047B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333EA8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052099305861343748990000013736273985181812372_)"
    },
    d: "M342.45,196.95l27.12,10.6 c-0.61-0.09-1.24-0.14-1.89-0.13c-9.27,0.14-33.17,16.87-33.17,16.87l-10.43-9.85L342.45,196.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068674499535987357000000007535916371803588797_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.9541,
    y1: 260.6998,
    x2: 370.6264,
    y2: 260.6998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B6ED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    style: {
      stopColor: "#796DD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    style: {
      stopColor: "#7268D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    style: {
      stopColor: "#6760C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    style: {
      stopColor: "#5655BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#4047B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333EA8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068674499535987357000000007535916371803588797_)"
    },
    d: "M370.63,249.59l-15.75,42.88 l-2.11,41.75c0,0-1.85,0.33-5.05,0.78c-15.01,2.14-60,7.27-88.14-3.32l10.96-51.87l-5.07-40.91l-61.15,6.76l-38.38-49.57 l5.11-3.89l11.76-8.95l36.26,35.42l56.75-24.8c2.06,1.49,3.85,2.22,3.85,2.22l-5.35,3.74l45.4,61.58 C319.74,261.41,361.21,251.36,370.63,249.59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011000839695750380470000008622040390303351207_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.5694,
    y1: 174.2926,
    x2: 291.6068,
    y2: 174.2926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7BE86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3293,
    style: {
      stopColor: "#F7BC83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#F7B67B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7276,
    style: {
      stopColor: "#F7AC6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      stopColor: "#F79E57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011000839695750380470000008622040390303351207_)"
    },
    d: "M291.61,187.76l-11.92,8.34 c0,0-1.78-0.73-3.85-2.22c-2.69-1.92-5.86-5.1-6.26-9.57c-0.52-6.01-10.65-15.78-13.96-21.61c-1.06-1.86-1.44-3.32-0.58-4.11 c1.09-1.03,3.52-2.33,6.36-3.47c6.3-2.5,14.7-4.21,15.47-0.31c0.02,0.09,0.05,0.2,0.08,0.31c0.36,1.53,1.42,4.3,2.85,7.58 C284.12,172.76,291.61,187.76,291.61,187.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124875951059345002460000016961759514719079828_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.3422,
    y1: 246.1504,
    x2: 370.6264,
    y2: 246.1504
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3C0887"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#3F0987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    style: {
      stopColor: "#470E87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7129,
    style: {
      stopColor: "#561588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8732,
    style: {
      stopColor: "#6B1F89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#822A8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38,
      fill: "url(#SVGID_00000124875951059345002460000016961759514719079828_)"
    },
    d: "M354.88,292.47 c-69.46-14.73-80.54-92.64-80.54-92.64l45.4,61.63l50.88-11.87L354.88,292.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107558967752400956730000004682095641047143600_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.1426,
    y1: 182.1903,
    x2: 345.8098,
    y2: 182.1903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7BE86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3293,
    style: {
      stopColor: "#F7BC83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5448,
    style: {
      stopColor: "#F7B67B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7276,
    style: {
      stopColor: "#F7AC6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      stopColor: "#F79E57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79244"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107558967752400956730000004682095641047143600_)"
    },
    d: "M342.06,159.09 c1.47-0.41,2.96-0.11,3.55,2.24c1.38,5.36-4.64,11.81-4.64,11.81l1.49,23.82l-18.37,17.5l7.19-20.58l-18.12,1.19l-10.85-1.19 l-3.03-2.86c0,0-2.11-19.75-2.11-31.34c0-2.67,0.11-4.91,0.39-6.36l0.09-0.56c12.7,2.14,30.32-2.81,30.32-2.81 s2.47,24.05,5.85,24.47c3.38,0.41,4.43-13.07,4.43-13.07S340.15,159.61,342.06,159.09z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M342.2,141.61l-0.14,17.48c-1.91,0.52-3.83,2.24-3.83,2.24s-1.05,13.48-4.43,13.07 c-3.38-0.42-5.85-24.47-5.85-24.47s-17.62,4.96-30.32,2.81v-0.02c-3.99-0.66-7.48-2.03-9.79-4.47 c-9.71-10.23-6.33-16.03,7.58-12.87C309.34,138.54,338.19,121.8,342.2,141.61z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "331.27,193.87 324.07,214.45 313.14,204.13 313.14,195.06  "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M296.41,155.92c2.79-1.4,5.7-1.57,8.64-0.51c1.79,0.65,0.44,3.29-1.33,2.65 c-1.85-0.67-3.94-0.53-5.69,0.35C296.34,159.25,294.71,156.77,296.41,155.92z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9986 -0.0522 0.0522 0.9986 -8.0676 17.109)",
    className: "st10",
    cx: 323.39,
    cy: 162.95,
    rx: 2.13,
    ry: 3.16
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M327.11,155.21c-2.93-1.1-5.83-0.97-8.65,0.39c-1.72,0.83-0.1,3.32,1.6,2.5c1.77-0.86,3.86-0.94,5.7-0.25 C327.53,158.51,328.9,155.88,327.11,155.21z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M306.53,172.73c0.95-4.48,3.26-9.04,4.83-13.35c0.33-0.9,1.65-0.22,1.32,0.67 c-0.99,2.72-1.97,5.43-2.96,8.15c-0.34,0.94-1.17,2.5-1.27,3.49c-0.32,3.38,1.22,3.12,2.98,3.93c0.87,0.4,0.2,1.73-0.67,1.32 C308.61,175.94,305.88,175.81,306.53,172.73z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M304.9,163.32c-1.39-1.12-2.96-1.85-4.74-2.08c-1.09-0.14-1.54,1.54-0.44,1.68 c0.89,0.11,1.74,0.37,2.53,0.75c-0.93,0.3-1.85,0.6-2.77,0.9c-1.06,0.34-0.62,2.02,0.45,1.68c1.52-0.49,3.05-0.99,4.57-1.48 C305.06,164.59,305.44,163.76,304.9,163.32z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 312.07,
    cy: 185.96,
    rx: 3.86,
    ry: 5.57
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152954453216082854070000014795728847842771124_",
    gradientUnits: "userSpaceOnUse",
    x1: 487.6912,
    y1: 841.2055,
    x2: 489.562,
    y2: 712.1162
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8AEBD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#89E9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#84E2DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    style: {
      stopColor: "#7DD7DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8419,
    style: {
      stopColor: "#72C6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    style: {
      stopColor: "#64B0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#5395F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5193FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000152954453216082854070000014795728847842771124_)"
    },
    d: "M843.69,705.16H147.73 c0,0-37.45,24.86,18.23,29.07c55.67,4.21,142.51,8.18,140.37,27.13c-2.14,18.94-52.42,15.2-52.42,48.64 c0,33.44,231.9,25.72,231.9,25.72s131,1.71,149.66-20.42c18.65-22.14-52.81-42.41-39.84-51.14 c12.97-8.73,107.14,17.46,121.17-3.74c14.03-21.2-2.81-34.61,23.07-37.42C765.74,720.2,839.32,730.35,843.69,705.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005266859780034503160000001043829386350075266_",
    gradientUnits: "userSpaceOnUse",
    x1: 791.0701,
    y1: 832.9209,
    x2: 791.0701,
    y2: 719.2662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8AEBD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#89E9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#84E2DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    style: {
      stopColor: "#7DD7DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8419,
    style: {
      stopColor: "#72C6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    style: {
      stopColor: "#64B0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#5395F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5193FA"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000005266859780034503160000001043829386350075266_)"
    },
    cx: 791.07,
    cy: 749.2,
    rx: 52.62,
    ry: 14.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135677498633159688110000001702623322546527394_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.8256,
    y1: 832.9209,
    x2: 230.8256,
    y2: 719.2662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8AEBD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    style: {
      stopColor: "#89E9D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#84E2DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7461,
    style: {
      stopColor: "#7DD7DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8419,
    style: {
      stopColor: "#72C6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    style: {
      stopColor: "#64B0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#5395F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5193FA"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000135677498633159688110000001702623322546527394_)"
    },
    cx: 230.83,
    cy: 762.14,
    rx: 45.99,
    ry: 11.38
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 494.45,
    cy: 806.5,
    rx: 52.24,
    ry: 10.06
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126324708174286114690000000539105961611509392_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.1261,
    y1: 343.496,
    x2: 571.8542,
    y2: 343.496,
    gradientTransform: "matrix(0.9797 0.2002 -0.2002 0.9797 81.2157 190.7862)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#31D1D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3733,
    style: {
      stopColor: "#32CED8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6175,
    style: {
      stopColor: "#36C6DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#3CB7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45A3FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126324708174286114690000000539105961611509392_)"
    },
    d: "M563.54,571.33 c-10.72-24.51-30.82-39.77-60.31-45.79c-3.21-0.66-6.35-1.18-9.42-1.56c-26.02-3.3-47.47,2.91-64.37,18.63 c-18.91,17.55-32.85,48.37-41.87,92.46c-5.52,27.01-7.06,50.37-4.61,70.09h64.45c-0.82-11.52,1.46-30.35,6.8-56.47 c5.78-28.25,11.5-47.33,17.17-57.25c3.3-5.76,7.02-9.56,11.19-11.4c3-1.34,6.24-1.65,9.7-0.94c8.26,1.7,13.01,8.41,14.26,20.14 c1.25,11.74-0.94,31.34-6.54,58.8c-4.21,20.59-8.45,36.28-12.68,47.12h70.66c3.28-10.15,6.16-21.32,8.64-33.51 c1.65-8.07,2.95-15.8,3.89-23.21C574.54,616.87,572.21,591.17,563.54,571.33z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024717093746330355390000011999106801277699218_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.4113,
    y1: 717.5402,
    x2: 458.5405,
    y2: 622.1264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9E6D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#FCF1EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    style: {
      stopColor: "#FEF9F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#FFFEFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024717093746330355390000011999106801277699218_)"
    },
    d: "M545.49,567.65 c-9.63-22.01-26.85-36.58-51.67-43.67c-2.79-0.8-5.67-1.51-8.65-2.12c-30.28-6.19-54.88-0.5-73.78,17.07 c-18.89,17.57-32.85,48.39-41.85,92.46c-1.84,8.97-3.23,17.55-4.18,25.72c-2.1,17.95-2.08,33.98,0.07,48.04h64.37 c-0.09-0.42-0.14-0.83-0.19-1.27c-1.35-11.22,0.83-30.86,6.56-58.88c5.78-28.25,11.5-47.33,17.19-57.24 c5.67-9.92,12.63-14.03,20.88-12.33c3.38,0.69,6.17,2.22,8.36,4.6c3.21,3.43,5.15,8.6,5.9,15.52 c1.25,11.74-0.94,31.34-6.54,58.8c-4.72,23.03-9.45,39.96-14.21,50.8h70.99c3.75-11.1,7.02-23.48,9.83-37.17 C557.21,625.6,556.19,592.16,545.49,567.65z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "594.69,402.36 594.25,402.69 548.93,437.97 520.64,459.98 497.09,525.16 490.55,522.8  514.82,455.73 590.44,396.88  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181046165967225393510000000521719532010256293_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.9319,
    y1: 482.8629,
    x2: 622.9958,
    y2: 482.8629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B6ED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4804,
    style: {
      stopColor: "#796DD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    style: {
      stopColor: "#7268D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    style: {
      stopColor: "#6760C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8765,
    style: {
      stopColor: "#5655BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    style: {
      stopColor: "#4047B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333EA8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181046165967225393510000000521719532010256293_)"
    },
    d: "M616.4,548.64 c-5.15,6.12-12.18,10.32-19.06,14.4l-0.47-0.82c2.72-3.49,5.6-7.58,4.79-11.93c-0.57-2.97-2.76-5.32-5-7.32 c-3.8-3.35-8.03-6.17-11.66-9.7c-3.62-3.52-6.69-7.94-7.28-12.96c-0.76-6.59,2.79-12.82,4.18-19.3c0.56-2.6,0.75-5.38-0.29-7.82 c-2.32-5.52-9.35-6.78-14.92-9c-4.98-2.01-9.66-5.74-11.05-10.93c-2.01-7.53,3.35-15.23,2.62-22.98 c-0.5-5.41-4.35-10.25-9.33-12.31l45.32-35.28c7.68,6.66,14.31,15.49,14.4,25.57c0.03,6.38-2.55,12.45-4.39,18.56 c-0.73,2.46-1.35,5.03-0.9,7.54c0.71,3.85,3.78,6.76,6.61,9.49c5.85,5.6,11.72,12.42,11.62,20.52 c-0.1,9.09-7.86,17.19-6.5,26.17c0.87,5.74,5.29,10.32,7.06,15.84C624.57,534,621.55,542.52,616.4,548.64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018222521246559527620000001945560485679898776_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.654,
    y1: 829.7299,
    x2: 187.3808,
    y2: 829.7299,
    gradientTransform: "matrix(1 0 0 -1 0 936.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E368E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29AAE1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018222521246559527620000001945560485679898776_)"
    },
    d: "M187.38,106.72 c-1.67,0.13-2.76,0.54-3.78,1.94c-0.6-1.44-1.43-2.64-2.95-3.21c0.85,0.13,1.71,0.23,2.45,0.71c0.28,0.18,0.52,0.43,0.79,0.62 c0.09,0.07,0.21,0.1,0.33,0.07C185.24,106.32,186.27,106.44,187.38,106.72z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136385454011109359510000000875463818380751794_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.3346,
    y1: 823.5567,
    x2: 196.3346,
    y2: 786.6285,
    gradientTransform: "matrix(1 0 0 -1 0 936.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E368E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29AAE1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136385454011109359510000000875463818380751794_)"
    },
    d: "M197.95,123.84 c-4.18-0.81-8.23,1.93-9.03,6.11c-0.37,1.89-0.01,3.86,1,5.5c-0.98-4.17,1.6-8.35,5.77-9.33c3.13-0.74,6.39,0.53,8.2,3.19 C203.33,127.01,201.24,124.49,197.95,123.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106839805621025012570000011535856607129955471_",
    gradientUnits: "userSpaceOnUse",
    x1: 168.8832,
    y1: 823.5567,
    x2: 168.8832,
    y2: 786.6285,
    gradientTransform: "matrix(1 0 0 -1 0 936.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E368E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29AAE1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106839805621025012570000011535856607129955471_)"
    },
    d: "M170.5,123.84 c-4.18-0.81-8.22,1.93-9.03,6.11c-0.36,1.89-0.01,3.85,1,5.5c-0.98-4.17,1.61-8.34,5.78-9.32c3.13-0.73,6.38,0.53,8.19,3.19 C175.67,126.5,173.36,124.38,170.5,123.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026857505693344928820000011596676159792989065_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.7579,
    y1: 838.4174,
    x2: 182.7579,
    y2: 782.9951,
    gradientTransform: "matrix(1 0 0 -1 0 936.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E368E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29AAE1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026857505693344928820000011596676159792989065_)"
    },
    d: "M207.35,125.82 c-0.68-1.39-1.64-2.62-2.81-3.64l-2.1-1.54c-3.95-2.88-7.9-5.76-11.85-8.65l0,0c-0.32-0.28-0.68-0.51-1.07-0.67l-0.1-0.05l0,0 c-0.7-0.27-1.49-0.17-2.1,0.28l-6.9,5l0,0c-0.66,0.48-1.31,0.95-1.97,1.43c-0.65,0.48-1.23,0.94-1.84,1.4l-0.05-0.05l5.33-4.9 c-1.16-0.9-2.27-1.75-3.39-2.61c-1.16-0.9-2.15-0.93-3.33-0.06c-3.44,2.51-6.89,5.03-10.33,7.56l-3.1,2.27l0,0l-0.1,0.07 c-1.49,1.15-2.71,2.61-3.58,4.28c-1.8,3.77-1.78,7.58,0.17,11.4c0.8,1.55,1.95,2.9,3.35,3.94c2.66,2.08,6.07,2.95,9.4,2.4 c3.65-0.56,6.5-2.43,8.54-5.51c0.33-0.51,0.74-0.96,1.22-1.34c1.66-1.28,3.64-0.9,4.91,0.95c1.01,1.48,2.13,2.83,3.6,3.84 c2.82,1.92,5.93,2.63,9.27,1.99c4.54-0.87,7.71-3.52,9.36-7.83C209.24,132.39,208.96,129.04,207.35,125.82z M169.2,141.15 c-2.51,0.02-4.93-0.95-6.74-2.7c-1.1-1.04-1.83-2.33-2.51-3.66c-0.55-2.37-0.73-4.72,0.28-7.03c0.5-1.18,1.22-2.24,2.12-3.15 c3.8-3.75,9.91-3.71,13.66,0.09c1.78,1.8,2.78,4.23,2.79,6.75C178.78,136.81,174.47,141.17,169.2,141.15z M196.35,141.15 c-5.34,0-9.67-4.32-9.67-9.66c0-5.34,4.32-9.67,9.66-9.67c5.33,0,9.66,4.32,9.67,9.65C206.01,136.82,201.69,141.15,196.35,141.15 L196.35,141.15z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006687291209101269490000006199547627523429269_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.4494,
    y1: 835.387,
    x2: 192.7455,
    y2: 791.309,
    gradientTransform: "matrix(1 0 0 -1 0 936.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#24265D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#29AAE1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006687291209101269490000006199547627523429269_)"
    },
    d: "M118.03,140.38h-10.69v-17.84 c0-9.55,7.5-10.77,11.2-10.77c9.27,0,13.56,5.58,13.56,14.54C132.1,135.78,126.91,140.38,118.03,140.38z M118.85,118.21 c-2.08,0-4.44,1.22-4.44,4.8v10.96h2.57c4.72,0,7.74-1.77,7.74-7.66C124.71,120.54,122.94,118.21,118.85,118.21z M148.29,140.38 v-10.77c0-3.54-0.51-4.95-2.95-4.95c-2.12,0-3.81,1.61-3.81,5.35v10.37h-6.44v-28.13h6.44v11.16h0.23 c0.67-2.04,2.32-4.56,6.37-4.56c4.87,0,6.6,2.91,6.6,8.17v13.36H148.29z M218.95,125.13c-1.57,0-2.36,0.6-2.36,2.36v12.9h-6.44 v-14c0-5.1,2.67-7.07,7.07-7.07h4.01v5.82H218.95z M233.73,140.85c-7.55,0-10.38-3.93-10.38-11.04v-17.56h6.44v11.08h0.24 c0.67-1.8,2.36-4.48,6.6-4.48c4.83,0,7.62,3.5,7.62,10.85C244.25,137.04,239.9,140.85,233.73,140.85z M233.84,124.65 c-2.44,0.01-4.05,1.9-4.05,5.16c0,3.77,1.5,5.23,3.97,5.23s4.09-1.65,4.09-5.19c0-3.69-1.37-5.18-4.01-5.18V124.65z  M247.49,115.03L247.49,115.03c0-1.54,1.25-2.79,2.79-2.79h0.86c1.54,0,2.79,1.25,2.79,2.79l0,0c0,1.54-1.25,2.79-2.79,2.79 c0,0,0,0,0,0h-0.86C248.74,117.82,247.49,116.57,247.49,115.03C247.49,115.03,247.49,115.03,247.49,115.03z M247.49,140.38 v-21.06h6.44v21.06H247.49z M277.51,140.38h-6.46v-11.7c0-2.63-0.67-4.01-3.34-4.01c-2.44,0-3.42,1.3-3.42,4.01v11.7h-6.44v-11.7 c0-6.84,3.77-9.82,9.9-9.82c6.56,0,9.75,3.54,9.75,9.82L277.51,140.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137832536177487015830000011716760573902203581_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.3214,
    y1: 792.7762,
    x2: 277.7961,
    y2: 792.7762,
    gradientTransform: "matrix(1 0 0 -1 0 936.7769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#29AAE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#24265D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137832536177487015830000011716760573902203581_)"
    },
    d: "M211.66,144.24v0.68h-0.6v-0.68 c-0.47-0.08-0.74-0.39-0.74-0.97v-0.77h0.6v0.77c0,0.32,0.16,0.46,0.44,0.46c0.22,0.02,0.41-0.14,0.43-0.36c0-0.03,0-0.06,0-0.1 v-0.77h0.6v0.77C212.43,143.74,212.12,144.16,211.66,144.24z M213.5,144.96c-0.52,0-0.94-0.42-0.94-0.94 c0-0.52,0.42-0.94,0.94-0.94c0.56,0,0.9,0.35,0.9,0.94c0.06,0.46-0.26,0.88-0.72,0.95C213.62,144.97,213.56,144.97,213.5,144.96 L213.5,144.96z M213.5,143.57c-0.21,0-0.35,0.14-0.35,0.44s0.14,0.44,0.35,0.44s0.35-0.14,0.35-0.44S213.72,143.58,213.5,143.57 L213.5,143.57z M215.45,144.96c-0.41,0.05-0.78-0.24-0.83-0.65c-0.01-0.06-0.01-0.13,0-0.19v-1.01h0.55v1.01 c0,0.23,0.07,0.34,0.29,0.34c0.22,0,0.3-0.11,0.3-0.34v-1.01h0.53v1.01c0.06,0.41-0.23,0.79-0.64,0.85 C215.58,144.97,215.51,144.97,215.45,144.96L215.45,144.96z M217.35,143.61c-0.14,0-0.2,0.05-0.2,0.2v1.1h-0.56v-1.2 c-0.04-0.29,0.16-0.56,0.45-0.6c0.05-0.01,0.1-0.01,0.15,0h0.34v0.5L217.35,143.61z M220.55,144.96h-0.97 c-0.45,0.06-0.86-0.26-0.91-0.71c-0.01-0.06-0.01-0.13,0-0.19v-1.54h0.6v1.5c0,0.3,0.14,0.41,0.36,0.41h0.13v-1.9h0.6v1.9h0.14 c0.22,0,0.36-0.12,0.36-0.41v-1.5h0.6v1.54c0.05,0.45-0.27,0.86-0.72,0.91C220.67,144.97,220.61,144.97,220.55,144.96 L220.55,144.96z M222.6,144.96c-0.52,0-0.94-0.42-0.94-0.94c0-0.52,0.42-0.94,0.94-0.94c0.57,0,0.9,0.35,0.9,0.94 c0.06,0.46-0.26,0.88-0.72,0.95C222.72,144.97,222.65,144.97,222.6,144.96L222.6,144.96z M222.6,143.57 c-0.21,0-0.35,0.14-0.35,0.44s0.14,0.44,0.35,0.44s0.35-0.14,0.35-0.44S222.82,143.58,222.6,143.57L222.6,143.57z M224.47,143.61 c-0.14,0-0.2,0.05-0.2,0.2v1.1h-0.55v-1.2c-0.04-0.29,0.16-0.56,0.45-0.6c0.05-0.01,0.1-0.01,0.15,0h0.34v0.5L224.47,143.61z  M225.48,144.92c-0.29,0.04-0.56-0.17-0.6-0.46c-0.01-0.05-0.01-0.09,0-0.14v-1.8h0.55v1.71c0,0.15,0.07,0.2,0.2,0.2h0.1v0.5 L225.48,144.92z M226.74,144.96c-0.58,0-0.9-0.34-0.9-0.96s0.3-0.93,0.71-0.93c0.24-0.02,0.45,0.15,0.5,0.38h0.04v-0.95h0.55v1.5 C227.63,144.62,227.34,144.97,226.74,144.96L226.74,144.96z M226.76,143.57c-0.23,0-0.36,0.13-0.36,0.44 c0,0.32,0.13,0.44,0.34,0.44c0.21,0,0.35-0.12,0.35-0.45C227.09,143.75,226.96,143.58,226.76,143.57L226.76,143.57z  M229.97,144.96c-0.78,0-1.17-0.48-1.17-1.25c0-0.77,0.42-1.25,1.17-1.25c0.74,0,1.16,0.44,1.16,1.25 C231.12,144.47,230.74,144.97,229.97,144.96L229.97,144.96z M229.97,143.02c-0.35,0-0.53,0.22-0.53,0.7s0.19,0.7,0.53,0.7 c0.35,0,0.53-0.23,0.53-0.7C230.5,143.24,230.32,143.03,229.97,143.02L229.97,143.02z M231.98,143.8v1.12h-0.55v-1.8 c-0.04-0.29,0.16-0.56,0.45-0.6c0.05-0.01,0.1-0.01,0.15,0h0.3v0.5h-0.15c-0.13,0-0.2,0.05-0.2,0.2v0.09h0.35v0.5L231.98,143.8z  M234.68,143.06v1.86h-0.6v-1.86h-0.72v-0.55h2.02v0.55H234.68z M236.32,143.61c-0.14,0-0.2,0.05-0.2,0.2v1.1h-0.55v-1.2 c-0.04-0.29,0.16-0.56,0.45-0.6c0.05-0.01,0.1-0.01,0.15,0h0.34v0.5L236.32,143.61z M237.89,144.92v-0.35h-0.02 c-0.06,0.24-0.29,0.4-0.54,0.38c-0.38,0-0.68-0.3-0.68-0.92c-0.06-0.47,0.28-0.9,0.76-0.96c0.05-0.01,0.1-0.01,0.15,0 c0.65,0,0.9,0.34,0.9,0.95v0.9H237.89z M237.55,143.57c-0.21,0-0.35,0.14-0.35,0.45c0,0.31,0.13,0.44,0.35,0.44 c0.22,0,0.34-0.16,0.34-0.44C237.89,143.7,237.76,143.58,237.55,143.57L237.55,143.57z M239.46,145.01l-0.98-1.9h0.6l0.37,0.88 l0.37-0.88h0.6L239.46,145.01z M242.13,144.18H241c0.02,0.15,0.15,0.26,0.3,0.25h0.6v0.5h-0.6c-0.46,0.04-0.87-0.3-0.9-0.76 c0-0.06,0-0.11,0-0.17c-0.05-0.45,0.28-0.85,0.73-0.9c0.05-0.01,0.1-0.01,0.15,0c0.55,0,0.85,0.32,0.84,0.9 C242.13,144.06,242.12,144.19,242.13,144.18L242.13,144.18z M241.29,143.58c-0.15-0.01-0.29,0.11-0.3,0.26h0.6 C241.57,143.69,241.49,143.58,241.29,143.58L241.29,143.58z M242.97,144.92c-0.29,0.04-0.56-0.17-0.6-0.46 c-0.01-0.05-0.01-0.09,0-0.14v-1.8h0.56v1.71c0,0.15,0.07,0.2,0.2,0.2h0.1v0.5L242.97,144.92z M243.69,145.29h-0.53l0.48-1.02 h0.53L243.69,145.29z M245.68,144.92h-0.39v-0.55h0.28c0.22,0,0.35-0.05,0.35-0.34v-1.52h0.6v1.6 C246.52,144.72,246.24,144.93,245.68,144.92L245.68,144.92z M247.68,144.96c-0.41,0.05-0.78-0.24-0.83-0.65 c-0.01-0.06-0.01-0.13,0-0.19v-1.01h0.55v1.01c0,0.23,0.07,0.34,0.3,0.34s0.3-0.11,0.3-0.34v-1.01h0.55v1.01 c0.06,0.41-0.23,0.79-0.64,0.85C247.83,144.98,247.75,144.98,247.68,144.96L247.68,144.96z M249.54,143.62 c-0.13,0-0.17,0.07-0.09,0.19l0.3,0.41c0.15,0.18,0.13,0.45-0.05,0.61c-0.09,0.08-0.21,0.11-0.33,0.1h-0.53v-0.5h0.25 c0.14,0,0.18-0.08,0.09-0.2l-0.3-0.42c-0.15-0.19-0.12-0.46,0.07-0.6c0.09-0.07,0.2-0.1,0.31-0.09h0.52v0.5H249.54z  M250.71,144.92c-0.29,0.04-0.56-0.17-0.6-0.46c-0.01-0.05-0.01-0.09,0-0.14v-1.8h0.55v0.6h0.36v0.5h-0.36v0.6 c0,0.15,0.07,0.21,0.2,0.21h0.16v0.5L250.71,144.92z M253.31,144.96c-0.77,0-1.16-0.48-1.16-1.25s0.42-1.25,1.16-1.25 c0.74,0,1.16,0.44,1.16,1.25C254.46,144.47,254.09,144.97,253.31,144.96L253.31,144.96z M253.31,143.02 c-0.35,0-0.53,0.22-0.53,0.7s0.19,0.7,0.53,0.7c0.34,0,0.53-0.23,0.53-0.7C253.84,143.25,253.66,143.03,253.31,143.02 L253.31,143.02z M256.41,144.92h-0.55v-1.01c0-0.23-0.06-0.34-0.29-0.34c-0.23,0-0.3,0.11-0.3,0.34v1.01h-0.55v-1.01 c0.03-0.46,0.43-0.82,0.89-0.79c0.43,0.03,0.77,0.37,0.79,0.79L256.41,144.92z M258.35,144.18h-1.13 c0.02,0.15,0.15,0.26,0.3,0.25h0.6v0.5h-0.6c-0.46,0.04-0.86-0.3-0.9-0.76c-0.01-0.06,0-0.12,0-0.18 c-0.05-0.45,0.28-0.85,0.72-0.9c0.05-0.01,0.11-0.01,0.16,0c0.55,0,0.84,0.32,0.84,0.9 C258.35,144.06,258.34,144.19,258.35,144.18L258.35,144.18z M257.51,143.58c-0.15-0.01-0.29,0.11-0.3,0.26h0.6 C257.79,143.69,257.69,143.58,257.51,143.58L257.51,143.58z M260.65,144.93c-0.8,0-1.2-0.44-1.2-1.2s0.44-1.2,1.2-1.2h0.65v0.55 h-0.55c-0.41,0-0.68,0.16-0.68,0.65c0,0.5,0.26,0.66,0.68,0.66h0.55v0.55L260.65,144.93z M262.15,144.93 c-0.29,0.04-0.56-0.16-0.6-0.45c-0.01-0.05-0.01-0.1,0-0.15v-1.8h0.55v1.71c0,0.15,0.07,0.2,0.2,0.2h0.1v0.5L262.15,144.93z  M262.62,143v-0.48h0.55V143H262.62z M262.62,144.93v-1.8h0.55v1.8H262.62z M264.37,144.93c-0.45,0.06-0.86-0.26-0.92-0.71 c-0.01-0.06-0.01-0.13,0-0.19c-0.04-0.46,0.29-0.86,0.75-0.9c0.06-0.01,0.11,0,0.17,0h0.43v0.5h-0.43 c-0.23,0-0.37,0.11-0.37,0.41s0.15,0.41,0.37,0.41h0.43v0.5L264.37,144.93z M266.24,143.81c0.3,0.05,0.42,0.24,0.42,0.55v0.57 h-0.56v-0.5c0-0.14-0.07-0.2-0.2-0.2h-0.27v0.69h-0.55v-2.4h0.55v1.37l0.46-0.77h0.63L266.24,143.81z M269.29,144.93v-0.65h-0.84 v0.65h-0.6v-1.45c0-0.7,0.42-1,1.03-1c0.66,0,1.03,0.3,1.03,1v1.45H269.29z M269.29,143.48c0-0.34-0.17-0.45-0.42-0.45 s-0.42,0.13-0.42,0.45v0.25h0.84L269.29,143.48z M272.09,144.98c-0.22,0.02-0.44-0.08-0.56-0.27c-0.12,0.19-0.35,0.3-0.58,0.27 c-0.55,0-0.76-0.3-0.76-0.84v-1.01h0.55v1.01c0,0.23,0.06,0.34,0.25,0.34s0.26-0.11,0.26-0.34v-1.01h0.55v1.01 c0,0.23,0.06,0.34,0.26,0.34s0.25-0.11,0.25-0.34v-1.01h0.55v1.01c0,0.57-0.25,0.83-0.77,0.83L272.09,144.98z M274.34,144.94 v-0.35h-0.02c-0.06,0.24-0.29,0.4-0.53,0.38c-0.38,0-0.68-0.3-0.68-0.92c-0.06-0.47,0.28-0.9,0.76-0.96 c0.05-0.01,0.1-0.01,0.15,0c0.65,0,0.9,0.34,0.9,0.95v0.9H274.34z M274,143.6c-0.21,0-0.35,0.14-0.35,0.45s0.13,0.44,0.35,0.44 c0.22,0,0.34-0.16,0.34-0.44c0-0.34-0.13-0.46-0.34-0.46L274,143.6z M276.3,144.93v0.6h-0.55v-0.6 c-0.37-0.08-0.62-0.43-0.57-0.81v-1.01h0.55v1.01c0,0.23,0.06,0.34,0.3,0.34c0.24,0,0.3-0.11,0.3-0.34v-1.01h0.55v1.01 C276.93,144.51,276.67,144.86,276.3,144.93z M277.24,144.08v-1.57h0.56v1.57H277.24z M277.24,144.93v-0.65h0.56v0.65H277.24z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "DESIGNED_BY_FREEPIK"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e063618ba145c669e69620dbb97c77dc.svg";
export { ForwardRef as ReactComponent };